import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from '@ignitesales/neuro-application';
import classnames from "classnames";
import {triggerIgniteAction} from "@ignitesales/neuro-application/src/neuro-guide/state/index.mjs";
import {Modal} from "@ignitesales/neuro-application/src/neuro-ui/index.mjs";
import ContactForm from "./ContactForm";

const componentClass = 'contactFormModal';

const ContactFormModal = ({ isOpen, onComplete, onClose }) => {
    const dispatch = useDispatch();
    const classes = classnames(componentClass);

    useEffect(() => {
        if( isOpen ){
            dispatch(triggerIgniteAction({ actionName: 'contactMeClicked', value: 'started' }));
        }
    }, [isOpen]);

    const onFormComplete = (result) => {
        onComplete && onComplete(result);
        onClose();
    };

    return (
        <Modal
            show={isOpen}
            className={classes}
            title={null}
            onClose={onClose}
            closeBtn={<i className={`ion-md-close-circle-outline ${componentClass}__closeBtn`}/>}
            nodeId="root"
        >
            <ContactForm componentClass={componentClass} onComplete={onFormComplete} />
        </Modal>
    );
};
ContactFormModal.propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onComplete: PropTypes.func,
    title: PropTypes.any,
    useAppointmentFlow: PropTypes.bool,
    leadProcessor: PropTypes.string,
    cognitoConfig: PropTypes.any
};

export default ContactFormModal;
